import { render, staticRenderFns } from "./EditLinksModal.vue?vue&type=template&id=b77c3818&scoped=true&"
import script from "./EditLinksModal.vue?vue&type=script&lang=js&"
export * from "./EditLinksModal.vue?vue&type=script&lang=js&"
import style0 from "./EditLinksModal.vue?vue&type=style&index=0&id=b77c3818&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b77c3818",
  null
  
)

export default component.exports